import { useQuery } from 'react-query';
import getSupport from 'data/requests/getSupport';
import { Support } from 'model/support';

const useSupport = () => {
  const { data, isLoading } = useQuery<Support>('support', getSupport);
  return { support: data, isLoading };
};

export default useSupport;
